// 工具方法

import { result } from "lodash";

// 将指定的树状数据扁平化成 Hash Map
export const hashMapTree = (treeMap: any, resultMap: any, deep: number = 0, parentId: any = undefined) => {
  if (!treeMap || !resultMap) return;
  if (treeMap.length <= 0) return;
  treeMap.forEach(item => {
    if (item && item.id) {
      let dict = {
        id: item.id,
        type: item.type,
        name: item.cgName?.zh || item.details.descriptionShort.zh,
        csname: item.csName,
        parentId: parentId || item.parentId,
        deep: deep
      }
      resultMap[item.id] = dict
      if (item.children && item.children.length > 0) {
        hashMapTree(item.children, resultMap, deep + 1, item.id)
      }
    }
  })
}

// 根据提供的树状数据和当前节点的id，返回完整的面包屑路径
export const getBreadcrumbsPath = (resultMap: any, curId: any, resultPath: any) => {
  if (!curId || !resultMap || !resultPath) return;
  let lastNode = resultMap[curId]
  if (lastNode) {
    resultPath.push(lastNode)
    if (lastNode.parentId) {
      getBreadcrumbsPath(resultMap, lastNode.parentId, resultPath)
    }
  }
}

// 根据扁平化的树状结构和当前面包屑的路径，返回所有需要渲染的节点 id
export const getDisplayNodeIds = (resultMap: any, resultNodes: any, breadcrumbs: any = undefined) => {
  if (!resultMap) return;
  // 跟节点先装进去
  Object.keys(resultMap).forEach(key => {
    if (resultMap[key] && !resultMap[key].parentId) {
      resultNodes.push(resultMap[key].id)
    }
  })
  if (!breadcrumbs) return;
  
  breadcrumbs.forEach(item => {
    Object.keys(resultMap).forEach(key => {
      if (resultMap[key] && resultMap[key].parentId === item.id) {
        resultNodes.push(resultMap[key].id)
      }
    })
  })
}
